import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PartnerWizardComponent } from '../../cwc-partner-wizard';

/**
 * Definition of  parameters that the template needs to work.
 */
interface PartnerWizardPartnersHeaderTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: PartnerWizardComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const PartnerWizardPartnersHeaderTemplate: FunctionalComponent<PartnerWizardPartnersHeaderTemplateProps> = ({
  controller,
}) => (
  <div>
    <h3>{controller.textPartnersModalHeadline}</h3>

    {controller.textPartnersModalDescription && <p innerHTML={controller.textPartnersModalDescription} />}
  </div>
);

export default PartnerWizardPartnersHeaderTemplate;
